<router-outlet></router-outlet>
<as-page-loading-indicator style="position: absolute; z-index: 3000;"></as-page-loading-indicator>
